<template>
  <div class="login-content">
        <div class="containessr">
            <div class="row">
                <div class="col-lg-12 align-content-center">
                    <div class="container form-login">
                      <div class="row m-3 g-3 needs-validation form-fields">
                        <div class="mb-3">
                            <h3 v-if="title && title.length > 0">{{ title }}</h3>
                            <h3 v-else-if="!position" >{{ withAuth ? "Je m'inscris" : "Formulaire de prise de rendez-vous" }}</h3>
                            <h3 v-else-if="position" >{{ 'Saisissez vos information' }}</h3>
                        </div>
                        <!-- Initialisation des champs -->
                        <template v-for="(field, index) in fields" :key="index">
                            <div v-if="field.level != 'child'" class="field col-md-6">
                                <label class="form-label"
                                    >{{ field.name }}
                                    <span v-if="field.required || field.internal_col_name === 'email'">*</span></label
                                >
                                <!-- <input
                                    :type="field.data_type"
                                    class="form-control"
                                    :placeholder="field.description ?? ''"
                                    :id="`field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                    :data-efs-id="field.efs_id"
                                /> -->
                                <div class="control">
                                    <input
                                        v-if="field.data_type === 'telephone'"
                                        @input="formatPhone"
                                        class="form-control"
                                        type="tel"
                                        maxlength="14"
                                        :placeholder="field.description??''"
                                        :required="!!field.required"
                                        :readonly="isFieldReadonly(field)"
                                        :id="`field-${field.internal_col_name}`"
                                        :field_name="field.internal_col_name"
                                        :data-efs-id="field.efs_id"
                                        v-model="form_data[field?.internal_col_name]"
                                    >
                                    <input
                                        class="form-control"
                                        :type= "field.data_type"
                                        :placeholder="field.description ?? ''"
                                        v-else-if="field.data_type === 'number'"
                                        :required="!!field.required"
                                        :readonly="isFieldReadonly(field)"
                                        :id="`field-${field.internal_col_name}`"
                                        :field_name="field.internal_col_name"
                                        :data-efs-id="field.efs_id"
                                        min="0"
                                        v-model="form_data[field?.internal_col_name]"
                                    />
                                    <input 
                                        class="form-control"
                                        :type="field.data_type"
                                        :placeholder="field.description??''"
                                        v-else-if="field.data_type === 'email'"
                                        :required="!!field.required"
                                        :readonly="isFieldReadonly(field)"
                                        :id="`field-${field.internal_col_name}`"
                                        :field_name="field.internal_col_name"
                                        :data-efs-id="field.efs_id"
                                        :list="field.options && field.options.length > 0 ? 'autocomplete-list-'+`field-${field.internal_col_name}` : undefined"
                                        v-model="form_data[field?.internal_col_name]"
                                    >
                                    <input 
                                        class="form-control"
                                        :type="field.data_type"
                                        :placeholder="field.description??''"
                                        v-else-if="['text', 'date'].includes(field.data_type)"
                                        :required="!!field.required"
                                        :readonly="isFieldReadonly(field)"
                                        :id="`field-${field.internal_col_name}`"
                                        :field_name="field.internal_col_name"
                                        :data-efs-id="field.efs_id"
                                        :list="field.options && field.options.length > 0 ? 'autocomplete-list-'+`field-${field.internal_col_name}` : undefined"
                                        v-model="form_data[field?.internal_col_name]"
                                    >
                                    <textarea
                                        v-else-if="field.data_type === 'textarea'"
                                        name=""
                                        class="form-control"
                                        :required="!!field.required"
                                        :readonly="isFieldReadonly(field)"
                                        :id="`field-${field.internal_col_name}`"
                                        :field_name="field.internal_col_name"
                                        :placeholder="field.description??''"
                                        :data-efs-id="field.efs_id"
                                        v-model="form_data[field?.internal_col_name]"
                                    ></textarea>
                                    <div class="select is-rounded is-flex-grow-1 is-flex"
                                        v-if="field.data_type === 'select'"
                                    >
                                        <select name="" :id="`field-${field.internal_col_name}`" v-model="form_data[field?.internal_col_name]"
                                            :data-efs-id="field.efs_id"
                                            :required="!!field.required"
                                            :disabled="isFieldReadonly(field)" @change="on_field_change(true,field,$event)"
                                            class="form-select" :field_name="field.internal_col_name" :data-level="field.level"
                                            >
                                            <option value=""></option>
                                            <option v-for="(option, index) in field.options" :key="index" :value="option.value">{{option.label}}</option>
                                        </select>
                                    </div>
                                    <div v-else-if="field.data_type === 'checkbox'" :id="`field-${field.internal_col_name}`" class="form-check">
                                        <div v-for="(option, index) in field.options" :key="index">
                                            <label :for="`option-${field.efs_is}-${option.value}`" class="form-check-label" >
                                                <input class="form-check-input" :data-efs-id="field.efs_id" @change="on_field_change(true,field,$event)"
                                                    type="checkbox"
                                                    :name="field.internal_col_name"
                                                    :id="`option-${field.efs_is}-${option.value}`"
                                                    :value="option.value"
                                                    :field_name="field.internal_col_name"
                                                    :data-level="field.level"
                                                    :disabled="isFieldReadonly(field)"
                                                    v-model="form_data[field?.internal_col_name]"
                                                >
                                                {{option.label}}
                                            </label>
                                        </div>
                                    </div>

                                    <!-- Liste des options pour l'autocomplete -->
                                    <datalist :id="'autocomplete-list-'+`field-${field.internal_col_name}`">
                                        <option v-for="(autocomplete_option, autocomplete_index) in field.options" :key="autocomplete_index">{{ autocomplete_option.label }}</option>
                                    </datalist>
                                </div>
                                <!-- Initialisation sous champs associés :style="{display: field.default_value == subfield.parent_value ? 'block' : 'none' }" -->
                                <template v-if="field.level == 'parent' ">
                                    <div v-for="(subfield, sub_index) in getSubFields(field)" :key="index+'-'+sub_index" :style="{display: (field.efs_id == subfield.parent_id) && (form_data[field.internal_col_name]?.toLocaleLowerCase() == subfield.parent_value?.toLocaleLowerCase()) ? 'block' : 'none'}" :data-field_id="subfield.efs_id" :data-parent_id="subfield.parent_id" :data-parent_value="(subfield.parent_value+'').toLocaleLowerCase()">
                                        <label class="form-label">
                                            {{ subfield.name }}<span v-if="subfield.required || subfield.internal_col_name === 'email'">*</span>
                                        </label>
                                        <input 
                                            @input="formatPhone"
                                            class="form-control"
                                            type="tel"
                                            maxlength="14"
                                            :placeholder="subfield.description??''"
                                            v-if="subfield.data_type === 'telephone'"
                                            :required="!!subfield.required"
                                            :readonly="isFieldReadonly(subfield)"
                                            :id="`field-${subfield.internal_col_name}`"
                                            :field_name="subfield.internal_col_name"
                                            :data-efs-id="subfield.efs_id"
                                            :list="subfield.options && subfield.options > 0 ? 'sub-autocomplete-list-'+`field-${subfield.internal_col_name}` : undefined"
                                            v-model="form_data[subfield.internal_col_name]"
                                        >
                                        <input 
                                            class="form-control"
                                            :type="subfield.data_type"
                                            :placeholder="subfield.description??''"
                                            v-if="subfield.data_type === 'email'"
                                            :required="!!subfield.required"
                                            :readonly="isFieldReadonly(subfield)"
                                            :id="`field-${subfield.internal_col_name}`"
                                            :field_name="subfield.internal_col_name"
                                            :data-efs-id="subfield.efs_id"
                                            :list="subfield.options && subfield.options > 0 ? 'sub-autocomplete-list' : undefined"
                                            v-model="form_data[subfield.internal_col_name]"
                                        >
                                        <input
                                            class="form-control"
                                            :type="subfield.data_type"
                                            :placeholder="subfield.description??''"
                                            v-else-if="['text', 'date'].includes(subfield.data_type)"
                                            :required="!!subfield.required"
                                            :readonly="isFieldReadonly(subfield)"
                                            :id="`field-${subfield.internal_col_name}`"
                                            :field_name="subfield.internal_col_name"
                                            :data-efs-id="subfield.efs_id"
                                            :list="subfield.options && subfield.options > 0 ? 'sub-autocomplete-list' : undefined"
                                            v-model="form_data[subfield.internal_col_name]"
                                        >
                                        <input
                                            class="form-control"
                                            :type= "subfield.data_type"
                                            :placeholder="subfield.description ?? ''"
                                            v-else-if="subfield.data_type === 'number'"
                                            :required="!!subfield.required"
                                            :readonly="isFieldReadonly(subfield)"
                                            :id="`field-${subfield.internal_col_name}`"
                                            :field_name="subfield.internal_col_name"
                                            :data-efs-id="subfield.efs_id"
                                            :list="subfield.options && subfield.options > 0 ? 'sub-autocomplete-list' : undefined"
                                            min="0"
                                            v-model="form_data[subfield.internal_col_name]"
                                        />
                                        <textarea
                                            v-else-if="subfield.data_type === 'textarea'"
                                            name=""
                                            class="form-control"
                                            :required="!!subfield.required"
                                            :readonly="isFieldReadonly(subfield)"
                                            :id="`field-${subfield.internal_col_name}`"
                                            :field_name="subfield.internal_col_name"
                                            :placeholder="subfield.description??''"
                                            :data-efs-id="subfield.efs_id"
                                            v-model="form_data[subfield.internal_col_name]"
                                        ></textarea>
                                        <div class="select is-rounded is-flex-grow-1 is-flex" v-if="subfield.data_type === 'select'">
                                            <select name="" :id="`field-${subfield.internal_col_name}`"
                                                    :data-efs-id="subfield.efs_id" :required="!!subfield.required" 
                                                    :disabled="isFieldReadonly(subfield)"
                                                    class="form-select" :field_name="subfield.internal_col_name"
                                                    :data-level="subfield.level"
                                                    @change="on_field_change(false,subfield,$event)"
                                                    v-model="form_data[subfield.internal_col_name]"
                                                    >
                                                <option value=""></option>
                                                <option v-for="(option, index) in subfield.options" :key="index" :value="option.value">{{option.label}}</option>
                                            </select>
                                        </div>
                                        <div v-else-if="subfield.data_type === 'checkbox'" :id="`field-${subfield.internal_col_name}`" class="form-check">
                                            <div v-for="(option, index) in subfield.options" :key="index">
                                                <label :for="`option-${subfield.efs_is}-${option.value}`" class="form-check-label" >
                                                    <input class="form-check-input" :data-efs-id="subfield.efs_id"
                                                        type="checkbox"
                                                        :name="subfield.internal_col_name"
                                                        :id="`option-${subfield.efs_is}-${option.value}`"
                                                        :value="option.value"
                                                        :disabled="isFieldReadonly(subfield)"
                                                        :field_name="subfield.internal_col_name"
                                                        :data-level="subfield.level"
                                                        v-model="form_data[subfield.internal_col_name]"
                                                        @change="on_field_change(false,subfield,$event)"
                                                    >
                                                    {{option.label}}
                                                </label>
                                            </div>
                                        </div>
                                        <!-- Liste des options pour l'autocomplete -->
                                        <datalist :id="'sub-autocomplete-list-'+`field-${subfield.internal_col_name}`">
                                            <option v-for="(sub_autocomplete_option, sub_autocomplete_index) in field.options" :key="sub_autocomplete_index">{{ sub_autocomplete_option.label }}</option>
                                        </datalist>
                                    </div>
                                </template>
                            </div>
                        </template>

                        <div v-if="withAuth" class="field column is-full-desktop position-relative">
                            <label for="password" class="form-label">Mot de passe <span>*</span></label>
                            <div class="control position-relative">
                                <!-- <input class="form-control" :class="password_error ? 'input is-danger is-rounded' : 'input is-rounded'" type="password" name="" id="password" v-model="password" autocomplete="off"> -->
                                <input class="form-control" :class="password_error ? 'input is-danger is-rounded' : 'input is-rounded'" :type="showPassword ? 'text' : 'password'" id="password" v-model="password" autocomplete="off">
                                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" class="toggle-password" @click="showPassword = !showPassword"></i>
                            </div>    
                        </div>
                        <div v-if="withAuth" class="field column is-full-desktop position-relative">
                            <label for="password-confirm" class="form-label">Confirmation de mot de passe <span>*</span></label>
                            <div class="control position-relative">
                                <!-- <input class="form-control" :class="password_confirm_error ? 'input is-danger is-rounded' : 'input is-rounded'" type="password" name="" id="password-confirm" v-model="password_confirm" autocomplete="off"> -->
                                 <input class="form-control" :class="password_confirm_error ? 'input is-danger is-rounded' : 'input is-rounded'" :type="showPasswordConfirm ? 'text' : 'password'" id="password-confirm" v-model="password_confirm" autocomplete="off">
                                 <i  :class="showPasswordConfirm ? 'fa fa-eye-slash' : 'fa fa-eye'" class="toggle-password" @click="showPasswordConfirm = !showPasswordConfirm"></i>
                            </div>
                        </div>
                        <div class="col-12">
                            <div v-if="(config['RDV_FOR_SOMEONE_ELSE'] == 1) && (config['RDV_FOR_SOMEONE_ELSE_FORCE_AUTO'] != 1) && !form_only" class="form-check mb-4">
                                <input class="form-check-input" type="checkbox" value="" id="rdv_not_for_me" @change="set_rdv_not_for_me($event)">
                                <label class="form-check-label" for="rdv_not_for_me">
                                    je note un rdv pour une autre personne
                                </label>
                            </div>
                            <div v-if="!form_only" class="form-check">
                                <input id="aggreement" type="checkbox" class="form-check-input"  v-model="aggreement">
                                <label class="form-check-label" for="aggreement">
                                    <a target="_blank" href="https://mysimplyagenda.com/CGU_FO_My_Simply_Agenda.pdf">J'ai bien pris en compte et accepte les conditions générales d'utilisation</a>
                                    Les données personnelles enregistrées à partir de vos réponses font l'objet d'un traitement informatique. Le droit de la protection des données vous garantit un droit d'accès et de rectification de vos données. 
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.mysimplyagenda.com/Politique_de_confidentialite_FO_My_Simply_Agenda.pdf">En savoir plus</a>
                                </label>
                            </div>
                            <div v-if="error_message" style="color: red;">
                                {{ error_message }}
                            </div>
                        </div>
                        <div v-if="!form_only" class="col-12 mb-3 d-flex justify-content-between gap-2">
                          <button v-if="withAuth == 0" class="btn-primary1 w-50" type="submit" @click="saveWithoutAuth">Enregistrer</button>
                          <button v-else class="btn-primary1 w-50" type="submit" @click="save">Je m’inscris</button>
                          <button v-if="withAuth == 1" class="btn-secondary1 w-50" @click="showSignIn">Me Connecter</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'
import {toast} from 'bulma-toast'
import { BookingStore } from '../Stores/BookingStore';
import { validateEmail, validatePhone } from '../../../utils/validationUtils';
import { Utilities } from '../Utilities/utilities';


export default {
    name: 'SignUp',
    props: ["config","withAuth", "position", 'form_only', 'title', 'fieldConfig'],
    emits: ['submitWithoutAuth', 'sign-in', 'signed-up', 'rdv_not_for_me'],
    computed: {
        user() {
            return this.$page.props.auth.user?.client?.[0];
        },
    },
    data () {
        return {
            showAgreement: false,
            email: null,
            error_message: null,
            fields: [],
            is_loading: false,
            password: null,
            password_error: false,
            password_confirm: null,
            password_confirm_error: false,
            aggreement: false,
            rdv_not_for_me: false,
            form_data: {},
            showPassword: false,     
            showPasswordConfirm: false
        }
    },
    methods : {
        isFieldReadonly(field) {
            if (this.config['RDV_FOR_SOMEONE_ELSE'] == 1) {
                const key = `READONLY_FIELD-${field.efs_id}`;
                return this.config?.[key] == 1;
            }
            return false;
        },
        set_rdv_not_for_me(event, field=null){
            if(field == null){
                this.rdv_not_for_me = event.target.checked;
            }else{
                if(this.config['RDV_FOR_SOMEONE_ELSE_FIELD'] == field.efs_id){
                    // console.log('Signup set_rdv_not_for_me event value',this.config['RDV_FOR_SOMEONE_ELSE_FIELD_VALUE'],event.target?.value);
                    this.rdv_not_for_me = (this.config['RDV_FOR_SOMEONE_ELSE_FIELD_VALUE']?.toLocaleLowerCase() == event.target?.value?.toLocaleLowerCase());
                }
            }
            // console.log('Signup set_rdv_not_for_me',this.rdv_not_for_me);
            this.$emit('rdv_not_for_me', this.rdv_not_for_me);
        },
        showSignIn(){
            this.$emit('sign-in', false)
        },
        formatPhone(ev) {
            let input = ev.target;
            let value = input.value;
            let digits = value.replaceAll(/[^0-9]/g, "")
                    ?.match(/.{1,2}/g)
                    ?.join(".") ?? "";
            input.value = digits;
        },
        toggleModal () {
            if (this.is_loading) return false
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        getFields () {
            axios.get('/client/informations').then(response => {
                this.fields = response.data.fields.sort((a, b) => a.position - b.position);
                // Init form
                this.init_form();
            })
        },
        init_form(){
            this.fields.forEach((field) => {
                if(this.config['RDV_FOR_SOMEONE_ELSE'] == 1 && this.form_only && this.config['AUTO_FILL_IN_SECOND_FORM-'+field.internal_col_name] == 1){
                    this.form_data[field.internal_col_name] = BookingStore.user_infos?.[field.internal_col_name];
                }else{
                    this.form_data[field.internal_col_name] = field.default_value;
                }
            });
        },
        getFieldValue (field) {
            return this.user[field.internal_col_name] ?? ''
        },
        getSubFields (parent) {
            // console.log('Signup getSubfield',parent,this.fields.filter((field) => field.parent_id == parent.efs_id));       
            return this.fields.filter((field) => field.parent_id == parent.efs_id).sort((a, b) => a.position - b.position);
        },
        getIsChecked (field, option) {
            if (!this.user[field.internal_col_name]) return false
            return this.user[field.internal_col_name].split(',').includes(option)
        },
        passwordValid () {
            this.password_error = false
            this.password_confirm_error = false
            this.error_message = ''
            if (!this.password || this.password.length < 5) {
                this.password_error = true
                this.error_message = 'Le mot de passe doit contenir au moins 5 caractères.'
            }
            if (this.password != this.password_confirm) {
                this.password_confirm_error = true
                this.error_message ||= 'Les mots de passe ne sont pas identiques.'
            }
            if (this.password_error || this.password_confirm_error) {
                return false
            }
            return true
        },
        aggreementValid() {
            if(!this.aggreement){
                this.error_message = "Veuillez accepter les conditions générales d'utilisation en cochant la case";
                return false;
            }
            return true;
        },

        on_field_change(is_parent, field, event){
            // if(is_parent){
            //     this.update_subfields_visibility(field,event);
            // }
            if((this.config['RDV_FOR_SOMEONE_ELSE'] == 1) && (this.config['RDV_FOR_SOMEONE_ELSE_FORCE_AUTO'] == 1) && !this.form_only){
                this.set_rdv_not_for_me(event, field);
            }
        },

        update_subfields_visibility(field,event){
            document.querySelectorAll('[data-parent_id="'+field.efs_id+'"]').forEach(function(el) {
                el.style.display = 'none'; // Hides the element but keeps its space
            });
            document.querySelectorAll('[data-parent_id="'+field.efs_id+'"][data-parent_value="'+event.target.value+'"]').forEach(function(el) {
                el.style.display = 'block'; // Hides the element but keeps its space
            });
            // let elements = document.querySelectorAll('[data-parent_id="'+field.efs_id+'"][data-parent_value="'+event.target.value+'"]');
            // console.log('Signup update_subfields_visibility','[data-parent_id="'+field.efs_id+'"][data-parent_value="'+event.target.value+'"]',elements);
            
            // if(elements && elements.length > 0){
            //     for (let element of elements) {
            //         element.style.visibility = 'visible';
            //     }
            // }
        },

        validateDynamiqueField(){
            if (this.is_loading) return false

            let fields = document.querySelectorAll('.form-fields [field_name]')
            let data = {}
            for (let field of fields) {
                if (field.getAttribute('type') === 'checkbox' && !field.checked) continue
                let field_name = field.getAttribute('field_name')
                let elt = data[field_name]||[]
                if (field.value) elt.push(field.value)
                data[field_name] = elt
            }
            for (let key in data) {
                let field = this.fields.find(field => field.internal_col_name === key)
                // console.log(field.data_type);
                
                if (field.data_type !== "checkbox") data[key] = data[key].toString()
                if (field.data_type === "telephone" && data[key]) {
                    const validation = validatePhone(data[key], field.name);
                    if (!validation.valid) {
                        this.error_message = validation.message;
                        return false;
                    }
                }
                // Vérifier si afficher et requis
                const container_field = document.querySelector('[data-parent_id="'+field.parent_id+'"][data-field_id="'+field.efs_id+'"]');
                // if(container_field) console.log('validatedynamique container', container_field, (!container_field || (container_field && container_field.style.display !== 'none')));
                
                if (field.required && !data[key] && (!container_field || (container_field && container_field.style.display !== 'none')) == true) {
                    let field_name = field.name ? field.name?.toLowerCase() : null
                    this.error_message =
                        field_name ?
                        `Le champ "${field_name}" est obligatoire.` :
                        "Merci de renseigner tous les champs obligatoires."
                    return false
                }
                if(field.data_type === 'date'){
                    let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                    if (result){
                        data[key] = `${result[3]}/${result[2]}/${result[1]}`
                    }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                    }else{
                        let field_name = field.name.toLowerCase()
                        this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                        return false
                    }
                }
                if (field.data_type === "email" && data[key]) {
                    console.log('validate email');
                    console.log('validateEmail function:', validateEmail);
                    const validation = validateEmail(data[key], field.name);
                    if (!validation.valid) {
                        this.error_message = validation.message;
                        return false;
                    }
                }
                if (field.data_type === "number" && data[key]) {
                    let numberValue = Number(data[key].replace(/,/g, '.'));
                    let field_name = field.name?.toLowerCase() || key;
                    const configKey = `MAX_LIMITE-${field.efs_id}`;
                    let maxValue = this.config?.[configKey];
                    console.log('field_name', field_name,'numbervalue:', numberValue, 'maxlimite:', maxValue);
                    if (isNaN(numberValue) || numberValue < 0) {
                        this.error_message = `Le champ "${field_name}" doit être un nombre positif.`;
                        return false;
                    }
                    if (field.internal_col_name !== "zipcode" && numberValue > maxValue) {
                        this.error_message = `Le champ "${field_name}" doit être inférieur à "${maxValue}".`;
                        return false;
                    }
                    data[key] = numberValue;
                }
            }
            return data;
        },

        save () {
            if (this.is_loading) return false

            // let fields = document.querySelectorAll('.form-fields [field_name]')
            let fields = Array.from(document.querySelectorAll('.form-fields [field_name]'))
                      .filter(f => f.style.display !== 'none'); // only validate visible fields
            let data = {}
            for (let field of fields) {
                if (field.getAttribute('type') === 'checkbox' && !field.checked) continue
                let field_name = field.getAttribute('field_name')
                let elt = data[field_name] || []
                if (field.value) elt.push(field.value)
                data[field_name] = elt
            }
            for (let key in data) {
                let field = this.fields.find(field => field.internal_col_name === key)
                if (field.data_type !== "checkbox") data[key] = data[key].toString()
                if (field.required && !data[key]) {
                    let field_name = field.name ? field.name?.toLowerCase() : null
                    this.error_message =
                        field_name ?
                        `Le champ "${field_name}" est obligatoire.` :
                        "Merci de renseigner tous les champs obligatoires."
                    return false
                }
                if (field.data_type === "telephone" && data[key]) {
                    const validation = validatePhone(data[key], field.name);
                    if (!validation.valid) {
                        this.error_message = validation.message;
                        return false;
                    }
                }
                if(field.data_type === 'date'){
                    let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                    if (result){
                        data[key] = `${result[3]}/${result[2]}/${result[1]}`
                    }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                    }else{
                        let field_name = field.name.toLowerCase()
                        this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                        return false
                    }
                }
                if (field.data_type === "number" && data[key]) {
                    let numberValue = Number(data[key].replace(/,/g, '.'));
                    let field_name = field.name?.toLowerCase() || key;
                    const configKey = `MAX_LIMITE-${field.efs_id}`;
                    let maxValue = this.config?.[configKey];
                    console.log(maxValue);
                    
                    if (isNaN(numberValue) || numberValue < 0) {
                        this.error_message = `Le champ "${field_name}" doit être un nombre positif.`;
                        return false;
                    }
                    if (field.internal_col_name !== "zipcode" && numberValue > maxValue) {
                        this.error_message = `Le champ "${field_name}" doit être inférieur à "${maxValue}".`;
                        return false;
                    }
                    data[key] = numberValue;
                }
                if (field.data_type === "email" && data[key]) {
                    const validation = validateEmail(data[key], field.name);
                    if (!validation.valid) {
                        this.error_message = validation.message;
                        return false;
                    }
                }
            }
            // console.log(data)
            if (!this.passwordValid()) return false

            if(!this.aggreementValid()) return false;

            data.password = this.password
            data.password_confirm = this.password_confirm
            this.error_message = null
            this.is_loading = true
            axios.post('/client', data).then(response => {
                this.is_loading = false
                // this.$emit('signed-up')
                toast({
                    message: response?.data?.message || 'Inscription réussie.',
                    type: 'is-success',
                    duration: 3000,
                    pauseOnHover: true
                })
                
                Inertia.reload({ only: ['auth.user'] })
                this.$emit('signed-up')
                BookingStore.set_user_infos(this.$page.props.auth.user?.client?.[0]);
            }).catch(err => {
                this.is_loading = false
                if (err?.response?.data?.errors) { 
                    for (let error in err?.response?.data?.errors) {
                        err.response.data.errors[error].forEach(message => {
                            toast({
                                message: message,
                                type: 'is-danger',
                                duration: 8000,
                                pauseOnHover: true
                            })
                        });
                    }
                } else {
                    toast({
                        message: err.response?.data?.message  ?? 'Vos changements n\'ont pas pu être pris en compte.',
                        type: 'is-danger',
                        duration: 8000,
                        pauseOnHover: true
                    })
                }
            })
        },

        async saveWithoutAuth() {
            let data = this.validateDynamiqueField();
            if ((!this.form_only && !this.aggreementValid()) || data == false) return false;

            if (this.form_only) {
                return this.emit_client_infos(data);
            }

            // Cas de l'iframe : demander à Safari d'accorder l'accès aux cookies
            const granted = await Utilities.ensureCookieAccess();
            if (!granted) {
                // Fallback token si Safari refuse
                await this.saveWithToken(data);
                return;
            }

            // Validation des données avec cookies
            try {
                const response = await axios.post('/client/validate', { client: data }, { withCredentials: true });
                this.emit_client_infos(data);
            } catch (error) {
                if (error.response?.status == 403) {
                    let field = JSON.parse(error.response?.data?.message);
                    const container_field = document.querySelector(
                        `[data-parent_id="${field.parent_id}"][data-field_id="${field.efs_id}"]`
                    );
                    if (container_field && container_field.style.display == 'none') {
                        return this.emit_client_infos(data);
                    } else {
                        this.error_message = `La valeur du champ ${field.name} diffère de la première valeur déjà enregistrée`;
                    }
                } else {
                    this.error_message = error.response?.data?.message || "Une erreur est survenue.";
                }
                return false;
            }
        },

        async saveWithToken(data) {
            try {
                // Récupérer un token temporaire
                const tokenResponse = await axios.get('/client/form/token');
                const token = tokenResponse.data;

                // Envoyer la requête avec le token
                await axios.post('/client/validate/token', 
                    { client: data }, 
                    { headers: { 'X-Form-Token': token } }
                );

                this.emit_client_infos(data);
            } catch (error) {
                // this.error_message = error.response?.data?.message;
                if (error.response?.status == 403) {
                    // Vérifier si champ est affiché
                    let field = JSON.parse(error.response?.data?.message);
                    const container_field = document.querySelector('[data-parent_id="'+field.parent_id+'"][data-field_id="'+field.efs_id+'"]');
                    // console.log('impossible de retrouver container',field,container_field?.style?.display,container_field);
                    if(container_field && (container_field.style.display == 'none')){
                        return this.emit_client_infos(data);
                    }else{
                        this.error_message = `La valeur du champ ${field.name} diffère de la première valeur déjà enregistrée`;
                    }
                }else {
                    this.error_message = error.response?.data?.message || "Une erreur est survenue.";
                }
                return false;
            }
        },

        emit_client_infos(data) {
            if(data != false){
                this.$emit("submitWithoutAuth", data);
                BookingStore.set_user_infos(data);
                return true;
            }else{
                return false;
            }
        },

        cancel() {
            this.$inertia.get("/ressources");
        }
    },
    mounted () {
        console.log('Signup component');
        window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll
        this.getFields()
    },
    updated () {
        // console.log("Signup component updated form_data",this.form_data)
    }
}
</script>

<style scoped>
    .datetimepicker-dummy .datetimepicker-dummy-wrapper {
        border-radius: 20px;
    }

    #btn-signup {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

    #btn-signup:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }

    .position-relative {
        position: relative;
    }

    .toggle-password {
        position: absolute;
        right: 15px;
        top: 30%;
        cursor: pointer;
        color: #999;
    }

    .toggle-password:hover {
        color: #333;
    }
</style>
